<script>
export default {
    name: "DocFileInput",
    model: {
        prop: 'value', // 'value' для универсальности
        event: 'change', //было 'files-selected'
        // prop: 'file',
       //  event: 'files-selected',
    },
    props: {
        value: { // Может быть File или String (path)
            type: [File, String],
            default: null
        },
        // file: {
        //     type: File,
        //     default: function () {
        //         return null;
        //     }
        // },
        title: {
            type: String,
            default: function () {
                return '';
            },
        },
        titleShow: {
            type: String,
            default: function () {
                return '';
            },
        },
        httpRequest: Function,
    },
    data() {
        return {
            fileList: [],
            internalFileList: [],
            currentFilePath: '', // path from db
            showUploader: false,
            newFile: null,
        }
    },
    computed: {
        hasExistingFile() {
            return typeof this.value === 'string' && this.value !== '';
        },
        fileUrl() {
            if (!this.currentFilePath) return '';
            if (this.currentFilePath.startsWith('http://') || this.currentFilePath.startsWith('https://')) {
                return this.currentFilePath;
            }
            return '/storage/' + this.currentFilePath;
        }
    },
    watch: {
        value: {
            immediate: true, // Вызываем при инициализации
            handler(newValue) {
                if (typeof newValue === 'string' && newValue !== '') {
                    // поле path из базы
                    this.currentFilePath = newValue;
                    this.showUploader = false;
                    this.fileList = [];
                    this.newFile = null;
                } else if (newValue instanceof File) {
                    // Если объект File (новый файл)
                    this.newFile = newValue;
                    this.currentFilePath = '';
                    this.showUploader = true;
                    this.fileList = [{ name: newValue.name, raw: newValue, url: URL.createObjectURL(newValue) }];
                } else {
                    this.currentFilePath = '';
                    this.showUploader = true; // Показываем аплоадер
                    this.fileList = [];
                    this.newFile = null;
                }
            }
        }
    },
    methods: {
        validFile(file) {
            const fileType = file.type ?? file.raw.type;
            if (fileType && (fileType === 'application/pdf' || fileType.startsWith("image/"))) {
                return true;
            }
            this.$message.error("Файл не підтримується, тільки pdf чи зображення");

            return false
        },
        removeFile() {
            this.fileList = [];
            this.newFile = null; // Сбрасываем новый файл
            this.$emit("change", null); // Указываем, что файл удален
            this.$emit("remove-file"); // Для внешней логики
        },
        handleChange(file, fileList) {
            // Выбор файла в el-upload
            if (this.validFile(file)) {
                this.fileList = fileList.slice(-1);
                this.newFile = file.raw;
                this.$emit("change", file.raw); // emit uploaded file
            } else {
                // Если файл невалидный, очищаем список
                this.$refs.upload.clearFiles();
                this.fileList = [];
                this.newFile = null;
                this.$emit("change", null);
            }
        },
        getFileName(path) {
            if (!path) return '';

            const parts = path.split('/');
            return parts[parts.length - 1];
        },
        removeExistingFile() {
            this.currentFilePath = '';
            this.newFile = null;
            this.showUploader = true;
            this.$emit("change", '');
        },
        getFilesForUpload() {
            return this.newFile;
        }
    }
}
</script>

<template>
    <div>
        <div v-if="hasExistingFile && !showUploader" class="w-100 d-flex justify-content-end flex-lg-wrap text-right file-upload-box">
            <el-link :href="fileUrl" type="primary" class="el-button w-100 btn-show-doc" target="_blank" :underline="false">
                <slot>{{ titleShow || 'Переглянути файл заяви' }}</slot>
            </el-link>
            <!--                <el-button type="text" @click="removeExistingFile" class="ml-2">Удалить</el-button>-->
            <el-link class="btn-reload-doc" @click="showUploader = true">Оновити документ</el-link>
            <p>
<!--                Текущий файл:-->
<!--                <a :href="currentFilePath" target="_blank">{{ getFileName(currentFilePath) }}</a>-->
            </p>
        </div>
        <el-upload
            v-if="showUploader || !hasExistingFile"
            class="upload-file"
            ref="upload"
            action=""
            :http-request="httpRequest"
            :file-list="fileList"
            :before-upload="validFile"
            :on-change="handleChange"
            :on-remove="removeFile"
            :on-success="() => $emit('upload-success')"
            :auto-upload="httpRequest !== undefined"
            accept=".pdf, image/*"
        >
            <div slot="trigger" class="w-100">
                <slot name="button">
                    <el-button type="primary"
                               class="w-100"
                               v-if="fileList.length === 0"
                    >
                        <slot>{{ title || 'Прикріпити файл заяви' }}</slot>
                    </el-button>
                </slot>
            </div>
        </el-upload>
    </div>
</template>

<style scoped>
.file-name {
    text-align: center;
    span {
        font-size: 8px;
        color: #8C8C8C;
        cursor: pointer;
    }
}
.btn-show-doc {
    background-color: #FD9B14;
    color:#fff;
    &:hover {
         color:#fff;
         text-decoration: none;
         background-color: #fd9b14ba;
     }
}
.btn-reload-doc {
    font-size: 13px;
    color: #0084F3;
    text-decoration: underline;
    &:hover {
         text-decoration: none;
     }
}
.fade-enter-active, .fade-leave-active {
    transition: opacity 1s ease;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
.upload-file {
    width: 100%;
    display: block;
}
* >>> .el-upload--text {
    width: 100%;
}
* >>> .el-upload-list--text {
    text-align: center;
}
* >>> .el-upload {
    display: block;
}
</style>
